import React from "react";
import TimelineItem from "./TimelineItem";

import { useResources } from "@aetonix/hooks";

export default function CareplanUpdate(props) {
	const {
		localize,
	} = useResources();

	var notification = props.notification;
	var fname = notification.from.fname;
	var lname = notification.from.lname;
	var content = notification.content;
	var count = (content.sections || []).length;
	var screen = props.screen;
	var careplanupdates = localize("banner.careplan_hasUpdates", {
		fname: fname,
		lname: lname,
		count: count,
	});

	return (
		<TimelineItem content={careplanupdates} iconName="info"  notification={notification} screen={screen} />
	);
}
